"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _inflIcons = require("infl-icons");

var _icon = _interopRequireDefault(require("../icon"));

var _stageApiIcon = _interopRequireDefault(require("./stage-api-icon"));

var _stageGcrowdIcon = _interopRequireDefault(require("./stage-gcrowd-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledIcon = (
/*#__PURE__*/
0, _styledBase.default)(_icon.default, {
  target: "el75pdw0"
})(function (props) {
  return "\n    margin-bottom: ".concat(props.theme.spacing[2], "px;\n    width: ").concat(props.theme.fonts.size[7], "px;\n    max-width: ").concat(props.theme.fonts.size[7], "px;\n    min-width: ").concat(props.theme.fonts.size[7], "px;\n    fill: ").concat(props.theme.colors.neutral[2], ";\n  ");
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var placeholderIcons = {
  api_integration: (0, _core.jsx)(_stageApiIcon.default, null),
  g2_review: (0, _core.jsx)(_stageGcrowdIcon.default, null),
  question_with_video: (0, _core.jsx)(StyledIcon, {
    icon: "video"
  }),
  question_with_file: (0, _core.jsx)(StyledIcon, {
    icon: "file"
  })
};
var icons = {
  advocate_acceptance: (0, _core.jsx)(StyledIcon, {
    icon: "user-check"
  }),
  api_integration: (0, _core.jsx)(_stageApiIcon.default, null),
  community_discussion_reply: (0, _core.jsx)(StyledIcon, {
    icon: "reply-bubble"
  }),
  check_in: (0, _core.jsx)(StyledIcon, {
    icon: "map-pin"
  }),
  corporate_confirmation: (0, _core.jsx)(StyledIcon, {
    icon: "thumbs-up"
  }),
  influitive_group_join: (0, _core.jsx)(StyledIcon, {
    icon: "users"
  }),
  nps: (0, _core.jsx)(StyledIcon, {
    icon: "smiley-faces"
  }),
  online_action: (0, _core.jsx)(StyledIcon, {
    icon: "link"
  }),
  g2_review: (0, _core.jsx)(_stageGcrowdIcon.default, null),
  questions: (0, _core.jsx)(StyledIcon, {
    icon: "question-bubble"
  }),
  question_with_image: (0, _core.jsx)(StyledIcon, {
    icon: "image"
  }),
  question_with_video: (0, _core.jsx)(StyledIcon, {
    icon: "video"
  }),
  question_with_file: (0, _core.jsx)(StyledIcon, {
    icon: "file"
  }),
  quiz: (0, _core.jsx)(StyledIcon, {
    icon: "quiz"
  }),
  refer_prospect: (0, _core.jsx)(StyledIcon, {
    icon: "refer-prospect"
  }),
  review: (0, _core.jsx)(StyledIcon, {
    icon: "star-bubble"
  }),
  share_link: (0, _core.jsx)(StyledIcon, {
    icon: "share"
  }),
  twitter_follow: (0, _core.jsx)(StyledIcon, {
    icon: "twitter-follow"
  }),
  twitter_post: (0, _core.jsx)(StyledIcon, {
    icon: "twitter-post"
  }),
  update_profile: (0, _core.jsx)(StyledIcon, {
    icon: "pencil"
  })
};

var _default = function _default(_ref) {
  var icon = _ref.icon,
      stage = _ref.stage;
  return (0, _core.jsx)(_react.default.Fragment, null, icons[icon] || placeholderIcons[stage] || (0, _core.jsx)(_inflIcons.Icon, {
    icon: icon
  }));
};

exports.default = _default;